import { render, staticRenderFns } from "./processing-tab.vue?vue&type=template&id=815c9882&"
import script from "./processing-tab.vue?vue&type=script&lang=js&"
export * from "./processing-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports